// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let removalMethodEnum = {
    'Destroyed': 0,
    'Irradiated': 1
};

export default removalMethodEnum;
